export const formValidationErrorTitle = bfTranslate('Please fix invalid fields before submitting');
export const nameHasSpecialCharactersError = bfTranslate('Key names may not contain colons, quotation marks, or periods');
export const nameNotChangedError =  bfTranslate('Please enter a different name');
